import { frontendURL } from 'dashboard/helper/URLHelper';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/internal-chats'),
    name: 'wasapi_internal_chats',
    component: () => import('./pages/InternalChatsPage.vue'),
    meta: { permissions: ['administrator', 'agent'] },
  },
];
